<template>
  <div v-if="activeVenue">
    <vs-tabs
      position="top"
      class="tabs-shadow-none mt-4"
      style="overflow: visible !important"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        v-if="hasPermissionForActiveVenue('vp.vp.booking.viewbookingoverview')"
        icon-pack="feather"
        icon="icon-activity"
        :label="!isSmallerScreen ? 'Booking Overview' : ''"
        style="overflow: visible !important"
      >
        <div class="tab-general">
          <marcom-booking-overview />
        </div>
      </vs-tab>
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        v-if="hasPermissionForActiveVenue('vp.vp.booking.viewvenuesetups')"
        :label="!isSmallerScreen ? 'Venue Edit' : ''"
        style="overflow: visible !important"
      >
        <div class="tab-general">
          <marcom-venue-edit />
        </div>
      </vs-tab>
      <vs-tab
        icon-pack="feather"
        icon="icon-info"
        v-if="hasPermissionForActiveVenue('vp.vp.booking.viewpendingrequests')"
        :label="!isSmallerScreen ? 'Pending Requests' : ''"
      >
        <div class="tab-general">
          <pending-requests-overview :venueSpecific="true" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import MarcomBookingOverview from "./pages/MarcomBookingOverview.vue";
import MarcomVenueEdit from "./pages/MarcomVenueEdit.vue";
import { mapGetters } from "vuex";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import PendingRequestsOverview from "./guestRelations/pages/PendingRequestsOverview.vue";

export default {
  components: {
    MarcomBookingOverview,
    MarcomVenueEdit,
    PendingRequestsOverview
  },
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.FindActiveVenue, {
      venuePortalId: this.activeVenue.venueId,
    });
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetLocations);
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetCountryCodes);
    await this.$store.dispatch("marcom/" + VENUE_ACTIONS.GetBookingTags);
  },
  mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
